<ng-container *transloco="let t">
  <lib-input-container
    [label]="label"
    [width]="'full'"
    [markRequired]="true"
    [errorText]="errorMessage$ | async"
    [class.classification-invalid]="errorMessage$ | async"
  >
    <div class="mt-1">
      <lib-list
        [addMoreVisible]="
          (!choosenItems.length > 0 ||
            (typeId !== ClassificationTypes.BO && choosenItems.length < 3)) &&
          !readOnlyState
        "
        [addMoreText]="t(addButtonText)"
        (addMore)="addClassificationLibModal(addClassification)"
      >
        @for (
          classification of choosenItems;
          track trackByFn(i, classification);
          let i = $index
        ) {
          <div class="d-flex align-items-center position-relative">
            @if (!readOnlyState) {
              <lib-dot-indicator
                type="classification"
                [isVisible]="
                  showChangeIndicatorForIds.includes(classification.value)
                "
              />
            }
            <lib-list-item
              class="flex-grow-1"
              [removeVisible]="!readOnlyState"
              [editVisible]="!readOnlyState"
              [readOnlyState]="readOnlyState"
              [editMode]="false"
              (edit)="
                addClassificationLibModal(
                  addClassification,
                  classification.value
                )
              "
              (remove)="onRemoveClassification(i)"
              [title]="classification.value"
            >
              <div
                view-title
                class="choosenItems"
                tabindex="0"
                [ngClass]="
                  readOnlyState ? 'readonly d-flex align-items-center' : ''
                "
                (keydown.enter)="$event.target.firstChild.click()"
              >
                <span
                  class="choosen-label"
                  [libTooltip]="
                    classification.value +
                    ' - ' +
                    getclassificationLabel(classification)
                  "
                  triggers="click"
                  [ngClass]="
                    classification.label.length > 20 ? '' : 'short-label'
                  "
                >
                  {{ classification.value }}
                  {{ getclassificationLabel(classification) }}</span
                >
                @if (typeId !== ClassificationTypes.BO && !readOnlyState) {
                  <div class="prio">Prio-{{ classification.prio }}</div>
                }
              </div>
            </lib-list-item>
          </div>
        }
        @if (choosenItems.length === 0 && readOnlyState) {
          <lib-list-item
            [removeVisible]="!readOnlyState"
            [editVisible]="!readOnlyState"
            [readOnlyState]="readOnlyState"
            [editMode]="false"
            [error]="readOnlyState !== ReadonlyState.Reader"
          >
            <ng-container>
              <div class="choosenItems readonly choosen-label"></div>
            </ng-container>
          </lib-list-item>
        }
        <div
          class="link-button d-flex"
          [ngClass]="
            typeId === ClassificationTypes.BO && !linkButtonIsCollapsed
              ? 'BO'
              : ''
          "
        >
          <ng-container *ngTemplateOutlet="linkButton"></ng-container>
        </div>
        @if (!linkButtonIsCollapsed && typeId === ClassificationTypes.BO) {
          <div class="description">
            <div class="description-headline d-flex">
              {{ t('classifications_description_BO') }}
            </div>
            <div class="description-text">
              {{ t('classifications_description_text_BO') }}
            </div>
            <ul attr.id="area-description">
              @for (
                descriptionItem of descriptionItems;
                track trackByFn(i, descriptionItem);
                let i = $index
              ) {
                <li>
                  <div class="description-label">
                    <button
                      type="button"
                      class="btn btn-menu btn-expand"
                      (click)="
                        descriptionItem.isExpanded = !descriptionItem.isExpanded
                      "
                      [attr.aria-controls]="descriptionItem.identifier"
                      [attr.aria-expanded]="descriptionItem.isExpanded"
                    >
                      <span class="visually-hidden">{{
                        descriptionItem.identifier +
                          ' - ' +
                          getclassificationName(descriptionItem)
                      }}</span>
                      <lib-icon
                        [name]="!descriptionItem.isExpanded ? 'plus' : 'minus'"
                      ></lib-icon>
                    </button>
                    <span class="identifier"
                      >{{ descriptionItem.identifier }}
                      {{ getclassificationName(descriptionItem) }}</span
                    >
                    @if (descriptionItem.isExpanded) {
                      <div class="description-content" [tabindex]="0">
                        <span>
                          {{ getclassificationDescription(descriptionItem) }}
                        </span>
                      </div>
                    }
                  </div>
                </li>
              }
            </ul>
          </div>
        }
        @if (!linkButtonIsCollapsed && typeId !== ClassificationTypes.BO) {
          <div class="description">
            <div class="description-headline d-flex po-fo">
              <span>
                {{
                  typeId === ClassificationTypes.FO
                    ? t('classifications_description_FO')
                    : t('classifications_description_PO')
                }}
              </span>
            </div>
            @if (typeId === ClassificationTypes.FO) {
              <div class="description-text">
                {{ t('classifications_description_text_FO') }}
              </div>
            } @else {
              <div class="description-text">
                {{ t('classifications_description_text_PO') }}
              </div>
            }
            <ul id="area-description">
              <ng-container
                [ngTemplateOutlet]="descriptionTemplate"
                [ngTemplateOutletContext]="{
                  descriptionList: descriptionItems,
                }"
              >
              </ng-container>
            </ul>
          </div>
        }
      </lib-list>

      @if (!readOnlyState) {
        @if (typeId === ClassificationTypes.BO && choosenItems.length < 1) {
          <span class="help-text-above d-flex">{{
            t('classifications_description_BO_helptext')
          }}</span>
        }
        @if (typeId === ClassificationTypes.FO && choosenItems.length < 3) {
          <span class="help-text-above d-flex">{{
            t('classifications_description_FO_helptext')
          }}</span>
        }
        @if (typeId === ClassificationTypes.PO && choosenItems.length < 3) {
          <span class="help-text-above d-flex">{{
            t('classifications_description_PO_helptext')
          }}</span>
        }
      }
    </div>
  </lib-input-container>

  <ng-template #descriptionTemplate let-descriptionList="descriptionList">
    @for (
      descriptionItem of descriptionList;
      track trackByFn(i, descriptionItem);
      let i = $index
    ) {
      <li>
        <div
          [ngClass]="
            typeId !== ClassificationTypes.FO
              ? 'classification-level-' + descriptionItem.level
              : 'classification-level-' + descriptionItem.level + ' ' + typeId
          "
          class="d-flex align-items-center description-label-fo-po"
        >
          @if (
            (typeId === ClassificationTypes.FO && descriptionItem.level < 3) ||
            (typeId === ClassificationTypes.PO && descriptionItem.level < 4)
          ) {
            <button
              type="button"
              class="btn btn-menu btn-expand"
              (click)="descriptionItem.isExpanded = !descriptionItem.isExpanded"
              [attr.aria-controls]="descriptionItem.identifier"
              [attr.aria-expanded]="descriptionItem.isExpanded"
            >
              <span class="visually-hidden">{{
                descriptionItem.identifier +
                  ' - ' +
                  getclassificationName(descriptionItem)
              }}</span>
              <lib-icon
                [name]="!descriptionItem.isExpanded ? 'plus' : 'minus'"
              ></lib-icon>
            </button>
          }
          @if (
            (typeId === ClassificationTypes.FO && descriptionItem.level < 3) ||
            (typeId === ClassificationTypes.PO && descriptionItem.level < 4)
          ) {
            <div
              class="id-name-container"
              [libTooltip]="
                descriptionItem.identifier +
                ' - ' +
                getclassificationName(descriptionItem)
              "
              triggers="click"
              (keydown.enter)="$event.target.click()"
              [tabindex]="0"
            >
              <span class="identifier">{{ descriptionItem.identifier }}</span>
              <span class="classification-name">{{
                getclassificationName(descriptionItem)
              }}</span>
            </div>
          }
          @if (
            (typeId === ClassificationTypes.FO &&
              descriptionItem.level === 3) ||
            (typeId === ClassificationTypes.PO && descriptionItem.level === 4)
          ) {
            <div
              [tabindex]="0"
              class="final-level"
              [libTooltip]="
                descriptionItem.identifier +
                ' - ' +
                getclassificationName(descriptionItem)
              "
              triggers="click"
              (keydown.enter)="$event.target.click()"
            >
              <span class="identifier">{{ descriptionItem.identifier }}</span>
              <span class="classification-name">{{
                getclassificationName(descriptionItem)
              }}</span>
            </div>
          }
        </div>
        @if (
          descriptionItem.children?.length > 0 && descriptionItem.isExpanded
        ) {
          <ul [attr.id]="descriptionItem.identifier">
            <ng-container
              [ngTemplateOutlet]="descriptionTemplate"
              [ngTemplateOutletContext]="{
                descriptionList: descriptionItem.children,
              }"
            >
            </ng-container>
          </ul>
        }
      </li>
    }
  </ng-template>

  <ng-template #addClassification>
    <lib-modal
      (primaryButton)="onConfirmModal()"
      [title]="label"
      (closeModal)="closeModal()"
      [showCloseButton]="true"
      (secondaryButton)="closeModal()"
      [showSecondaryButton]="true"
      [showPrimaryButton]="true"
      [secondaryButtonText]="t('cancel_btn_form')"
      [primaryButtonText]="t('finished_btn')"
    >
      @if (editItemIdentifier) {
        <span class="help-text-modal d-flex">{{
          (activeLang$ | async) === 'sv'
            ? t('classifications_description_On_Change', {
                name: editItem.name,
              })
            : t('classifications_description_On_Change', {
                name: editItem.nameEng,
              })
        }}</span>
      }
      @if (!editItemIdentifier && typeId === ClassificationTypes.BO) {
        <span class="help-text-modal d-flex">{{
          t('classifications_description_BO_helptext')
        }}</span>
      }
      @if (!editItemIdentifier && typeId === ClassificationTypes.FO) {
        <span class="help-text-modal d-flex">{{
          t('classifications_description_FO_helptext')
        }}</span>
      }
      @if (!editItemIdentifier && typeId === ClassificationTypes.PO) {
        <span class="help-text-modal d-flex">{{
          t('classifications_description_PO_helptext')
        }}</span>
      }
      @if (typeId !== ClassificationTypes.BO) {
        <lib-input-container
          [label]="t('classification_section_title')"
          for="select_classification_section"
          [required]="true"
        >
          <lib-vinnova-dropdown
            [items]="avdelningItems$ | async"
            (ngModelChange)="modelAvdelningChange($event)"
            [(ngModel)]="selectedAvdelning"
            [placeholder]="t('classification_section_select')"
            [disabled]="maxSelectedClassifications && !editItemIdentifier"
            [id]="'select_classification_section'"
            [required]="true"
          >
          </lib-vinnova-dropdown>
        </lib-input-container>
      }
      @if (typeId !== ClassificationTypes.BO) {
        <lib-input-container
          [label]="t('classification_maingroup_title')"
          [required]="true"
          for="select_classification_maingroup"
        >
          <lib-vinnova-dropdown
            [items]="huvudGruppItems$ | async"
            (ngModelChange)="modelHuvudGruppChange($event)"
            [(ngModel)]="selectedHuvudgrupp"
            [placeholder]="t('classification_maingroup_select')"
            [disabled]="maxSelectedClassifications && !editItemIdentifier"
            [id]="'select_classification_maingroup'"
            [required]="true"
          >
          </lib-vinnova-dropdown>
        </lib-input-container>
      }

      @if (typeId === ClassificationTypes.PO) {
        <lib-input-container
          [label]="t('classification_group_title')"
          [required]="true"
          for="select_classification_group"
        >
          <lib-vinnova-dropdown
            [items]="gruppItems$ | async"
            (ngModelChange)="modelGruppChange($event)"
            [(ngModel)]="selectedGrupp"
            [placeholder]="t('classification_group_select')"
            [disabled]="maxSelectedClassifications && !editItemIdentifier"
            [id]="'select_classification_group'"
            [required]="true"
          >
          </lib-vinnova-dropdown>
        </lib-input-container>
      }

      <lib-input-container
        [label]="t('classification_title')"
        [required]="true"
        for="select_classification"
      >
        <lib-vinnova-dropdown
          [items]="classificationItems$ | async"
          [(ngModel)]="selectedKlassificering"
          (ngModelChange)="confirmClassification()"
          [placeholder]="t('classification_select')"
          [disabled]="maxSelectedClassifications && !editItemIdentifier"
          [id]="'select_classification'"
          [required]="true"
        >
        </lib-vinnova-dropdown>
        <div></div>
      </lib-input-container>
      @if (typeId !== ClassificationTypes.BO) {
        <hr />
      }
      @if (typeId !== ClassificationTypes.BO) {
        <lib-input-container
          [required]="true"
          [label]="t('classification_search')"
          [width]="'full'"
          for="select_classification_search"
        >
          <div class="form-group search-container">
            <lib-vinnova-dropdown
              [items]="searchValues"
              [placeholder]="t('searchvalue_enter')"
              [(ngModel)]="selectedSearchValue"
              (ngModelChange)="onSelectSearchValue()"
              [isSearch]="true"
              [disabled]="maxSelectedClassifications && !editItemIdentifier"
              [id]="'select_classification_search'"
              [required]="true"
            >
            </lib-vinnova-dropdown>
          </div>
        </lib-input-container>
      }

      @if (maxSelectedClassifications && !editItemIdentifier) {
        <div class="maxselected-message">
          {{ t('classifications_max_selected') }}
        </div>
      }

      @if (choosenItemsWorkingCopy.length > 0) {
        <div class="choosen-header">
          {{
            editItemIdentifier
              ? t('classification_change')
              : t('classifications_choosen')
          }}
        </div>
      }

      <lib-list>
        @for (
          classification of choosenItemsWorkingCopy;
          track trackByFn(i, classification);
          let i = $index
        ) {
          @if (
            !editItemIdentifier || editItemIdentifier === classification.value
          ) {
            <lib-list-item
              [removeVisible]="!editItemIdentifier"
              [editMode]="false"
              (remove)="onRemoveClassificationWorkingCopy(i)"
              [title]="classification.value"
            >
              <div
                view-title
                class="choosenItems"
                [tabindex]="0"
                (keydown.enter)="$event.target.firstChild.click()"
              >
                <span
                  class="choosen-label modal-label"
                  [libTooltip]="
                    classification.value +
                    ' - ' +
                    getclassificationLabel(classification)
                  "
                  triggers="click"
                >
                  {{ classification.value }}
                  {{ getclassificationLabel(classification) }}</span
                >
                @if (typeId !== ClassificationTypes.BO) {
                  <div class="prio">Prio-{{ classification.prio }}</div>
                }
              </div>
            </lib-list-item>
          }
        }
      </lib-list>
    </lib-modal>
  </ng-template>

  <!-- Template -->
  <ng-template #linkButton let-buttonTexts="buttonTexts">
    <button
      vinnova-button-link
      type="button"
      size="small"
      (click)="linkButtonIsCollapsed = !linkButtonIsCollapsed"
      [attr.aria-expanded]="!linkButtonIsCollapsed"
      attr.aria-controls="area-description"
    >
      @if (linkButtonIsCollapsed) {
        <span
          >{{
            typeId === ClassificationTypes.PO
              ? t('classifications_description_PO_more')
              : typeId === ClassificationTypes.BO
                ? t('classifications_description_BO_more')
                : t('classifications_description_FO_more')
          }}
          <lib-icon
            class="icon-chevron"
            name="chevron-down"
            aria-hidden="true"
          ></lib-icon
        ></span>
      }
      @if (!linkButtonIsCollapsed) {
        <span
          >{{
            typeId === ClassificationTypes.PO
              ? t('classifications_description_PO_less')
              : typeId === ClassificationTypes.BO
                ? t('classifications_description_BO_less')
                : t('classifications_description_FO_less')
          }}
          <lib-icon
            class="icon-chevron"
            name="chevron-up"
            aria-hidden="true"
          ></lib-icon
        ></span>
      }
    </button>
  </ng-template>
</ng-container>
